var render, staticRenderFns
import script from "./PermissionsMixin.vue?vue&type=script&lang=ts"
export * from "./PermissionsMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bccefde')) {
      api.createRecord('8bccefde', component.options)
    } else {
      api.reload('8bccefde', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/PermissionsMixin.vue"
export default component.exports